
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import ContactModal from '../../../components/feature/ContactModal';

export default function ContactSection() {
  const { t } = useTranslation();
  const [isContactModalOpen, setIsContactModalOpen] = useState(false);

  const contactMethods = [
    {
      icon: 'ri-mail-line',
      titleKey: 'contact_email',
      descKey: 'contact_email_desc',
      contact: 'business@koluno.com',
      color: 'from-blue-500 to-cyan-500'
    },
    {
      icon: 'ri-telegram-fill',
      titleKey: 'contact_telegram',
      descKey: 'contact_telegram_desc',
      contact: '@koluno2020',
      color: 'from-green-500 to-emerald-500'
    },
    {
      icon: 'ri-wechat-line',
      titleKey: 'contact_wechat',
      descKey: 'contact_wechat_desc',
      contact: 'ljy520155',
      color: 'from-purple-500 to-pink-500'
    }
  ];

  return (
    <section id="contact" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            {t('contact_title')}
          </h2>
          <div className="w-24 h-1 bg-gradient-to-r from-purple-600 to-pink-600 mx-auto mb-8"></div>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            {t('contact_description')}
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 mb-16">
          {contactMethods.map((method, index) => (
            <div key={index} className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 text-center group">
              <div className={`w-16 h-16 bg-gradient-to-r ${method.color} rounded-2xl flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform duration-300`}>
                <i className={`${method.icon} text-white text-2xl`}></i>
              </div>
              
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                {t(method.titleKey)}
              </h3>
              
              <p className="text-gray-600 mb-4">
                {t(method.descKey)}
              </p>
              
              <div className="text-lg font-semibold text-gray-900 mb-6">
                {method.contact}
              </div>
              
              <button
                onClick={() => setIsContactModalOpen(true)}
                className="inline-flex items-center justify-center bg-gradient-to-r from-purple-600 to-pink-600 text-white px-6 py-3 rounded-lg font-medium hover:from-purple-700 hover:to-pink-700 transition-all duration-200 cursor-pointer whitespace-nowrap"
              >
                <i className="ri-external-link-line mr-2"></i>
                {t('btn_contact_now')}
              </button>
            </div>
          ))}
        </div>

        {/* 快速响应承诺 */}
        <div className="bg-gradient-to-r from-purple-600 to-pink-600 rounded-2xl p-8 text-white text-center">
          <h3 className="text-2xl font-bold mb-4">{t('contact_promise_title')}</h3>
          <div className="grid md:grid-cols-3 gap-6">
            <div>
              <div className="text-3xl font-bold mb-2">{t('contact_email_time')}</div>
              <div className="text-purple-100">{t('contact_email_time_desc')}</div>
            </div>
            <div>
              <div className="text-3xl font-bold mb-2">{t('contact_instant_time')}</div>
              <div className="text-purple-100">{t('contact_instant_time_desc')}</div>
            </div>
            <div>
              <div className="text-3xl font-bold mb-2">{t('contact_matching_time')}</div>
              <div className="text-purple-100">{t('contact_matching_time_desc')}</div>
            </div>
          </div>
        </div>
      </div>

      <ContactModal 
        isOpen={isContactModalOpen} 
        onClose={() => setIsContactModalOpen(false)} 
      />
    </section>
  );
}
